import React, { FC, Fragment } from 'react';
import { Box } from '@mui/system';
import { Address } from 'models/contact';
import { useTranslation } from 'react-i18next';

type FormattedAddressProps = {
    address?: Address;
    oneLineFormat?: boolean;
    hideCountry?: boolean;
};
const FormattedAddress: FC<FormattedAddressProps> = ({
    address,
    oneLineFormat,
    hideCountry,
}: FormattedAddressProps) => {
    const { t: translate } = useTranslation(['country-names']);

    const formattedStreet = (address: Address) => {
        let street = address.street;
        if (address.street2) {
            street += `, ${address.street2}`;
        }
        return street;
    };

    const formattedProvinceCountry = (address: Address) => {
        let country = translate(`country-names:COUNTRY_${address.country}`);
        if (address.stateProvince) {
            country = `${address.stateProvince}, ${country}`;
        }
        return country;
    };

    return (
        <Fragment>
            {address ? (
                <Fragment>
                    {oneLineFormat ? (
                        <Box>
                            {formattedStreet(address)}, {address.postalCode} {address.city}
                            {!hideCountry ? <span>, {formattedProvinceCountry(address)}</span> : undefined}
                        </Box>
                    ) : (
                        <Fragment>
                            <Box>{formattedStreet(address)}</Box>
                            <Box>{`${address.postalCode} ${address.city}`}</Box>

                            {!hideCountry ? <Box>{formattedProvinceCountry(address)}</Box> : undefined}
                        </Fragment>
                    )}
                </Fragment>
            ) : undefined}
        </Fragment>
    );
};

export default FormattedAddress;
